import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Texto from '../../commons/Texto';
import Modal from '../../commons/Modal';
import Tabla from '../../commons/Tabla';
import Boton from '../../commons/Boton';
import { confirmacion } from '../../commons/Mensajes';
import { formatoMonetario, redondeoDecimales } from '../../commons/Utilitarios';

import ServicioList from '../servicio/ServicioList';

import {
  closeModal,
  patchRecogerPedidoAction,
  patchListoPedidoAction,
} from '../../redux/actions/pedido.action';

import { getServiciosAction } from '../../redux/actions/servicio.action';

import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const PedidoPick = () => {
  const dispatch = useDispatch();
  const { selected, processing, errors } = useSelector((state) => state.pedido);

  const [pedido, setPedido] = useState(selected);
  const [detalle, setDetalle] = useState(selected.det);
  const [openServicio, setOpenServicio] = useState(false);
  const handleChange = (item) => {
    const { name, value } = item;
    setPedido((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getCategoria = (cc) => {
    switch (cc) {
      case 'LE':
        return 'Lavado premium';
      case 'LS':
        return 'Lavado al seco';
      case 'PL':
        return 'Planchado';
      default:
        return 'Lavado';
    }
  };

  const columns = [
    {
      key: 'co',
      align: 'center',
      content: (item) => (
        <div
          title={`${item.st === true ? 'Quitar' : 'Agregar'}`}
          style={{ display: 'inline-block' }}
        >
          {selected.me === 'NUEPED' || selected.me === 'RECPED' ? (
            item.st === true ? (
              <CheckIcon
                onClick={() =>
                  confirmacion(
                    '¿Está seguro?',
                    `De quitar ${item.ns} del pedido`
                  )
                    .then(() => handleTacharMaterial(item.sv, false))
                    .catch(() => {})
                }
                style={{ color: '#1ab394', cursor: 'pointer' }}
              />
            ) : (
              <CloseIcon
                onClick={() =>
                  confirmacion(
                    '¿Está seguro?',
                    `De volver agregar ${item.ns} al pedido`
                  )
                    .then(() => handleTacharMaterial(item.sv, true))
                    .catch(() => {})
                }
                style={{ color: 'red', cursor: 'pointer' }}
              />
            )
          ) : (
            <></>
          )}
        </div>
      ),
    },
    {
      key: 'ns',
      label: 'Prenda',
      content: (item) => (
        <span
          style={{
            color: `${item.st === true ? 'black' : 'red'}`,
            textDecoration: `${item.st === true ? 'none' : 'line-through'}`,
          }}
        >
          {item.ns}
        </span>
      ),
    },
    {
      key: 'cc',
      label: 'Categoria',
      content: (item) => (
        <span
          style={{
            color: `${item.st === true ? 'black' : 'red'}`,
            textDecoration: `${item.st === true ? 'none' : 'line-through'}`,
          }}
        >
          {getCategoria(item.cc)}
        </span>
      ),
    },
    {
      key: 'ps',
      label: 'Precio',
      align: 'right',
      content: (item) => (
        <div className="op-centrar-componentes">
          {formatoMonetario(redondeoDecimales(item.ps))}
        </div>
      ),
    },
    {
      key: 'ds',
      label: 'Descuento',
      align: 'right',
      content: (item) => (
        <div className="op-centrar-componentes">
          {formatoMonetario(redondeoDecimales(item.ds))}
        </div>
      ),
    },
    {
      key: 'ca',
      label: 'Cantidad',
      align: 'right',
      content: (item) => (
        <div className="op-centrar-componentes">
          {selected.me === 'NUEPED' || selected.me === 'RECPED' ? (
            <>
              <AddIcon
                style={{ color: 'green', cursor: 'pointer' }}
                onClick={() => handleCantidadMaterial(item.sv, 1)}
              />
              <div className={`cantidad${item.edit ? ' edit' : ''}`}>
                <span
                  style={{ color: `${item.st === true ? 'black' : 'red'}` }}
                  onClick={(e) =>
                    handleHabilitarEdicion(item.sv, !item.edit, 'edit', e)
                  }
                >
                  {item.ca}
                </span>
                <input
                  type="text"
                  value={item.ct}
                  onChange={(e) =>
                    handleEditarValor(item.mt, e.target.value, 'ca')
                  }
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleHabilitarEdicion(item.sv, !item.edit, 'edit', e);
                    } else {
                      let re = new RegExp('[0-9]');
                      if (!re.test(e.key)) {
                        e.preventDefault();
                      }
                    }
                  }}
                  onPaste={(e) => e.preventDefault()}
                  onFocus={(e) => e.target.select()}
                />
                <div className="edicion">
                  <EditIcon
                    style={{ fontSize: '15px' }}
                    onClick={(e) =>
                      handleHabilitarEdicion(item.sv, !item.edit, 'edit', e)
                    }
                  />
                </div>
              </div>
              <RemoveIcon
                style={{ color: 'red', cursor: 'pointer' }}
                onClick={() => handleCantidadMaterial(item.sv, -1)}
              />
            </>
          ) : (
            <span style={{ color: `${item.st === true ? 'black' : 'red'}` }}>
              {item.ca}
            </span>
          )}
        </div>
      ),
    },
    {
      key: 'su',
      label: 'SubTotales',
      align: 'right',
      content: (item) => (
        <span
          style={{
            color: `${item.st === true ? 'black' : 'red'}`,
            textDecoration: `${item.st === true ? 'none' : 'line-through'}`,
          }}
        >
          {`${formatoMonetario(
            redondeoDecimales(parseFloat(item.ps - item.ds) * parseInt(item.ca))
          )}`}
        </span>
      ),
    },
  ];

  const handleAgregarServicio = (item) => {
    let existe = detalle.find((x) => x.sv === item.sv);
    if (existe === undefined) {
      item.ca = 1;
      item.sv = item.sv;
      item.edit = false;
      setDetalle([...detalle, item]);
    }
  };

  const handleTacharMaterial = (sv, valor) => {
    setDetalle(
      detalle.map((x) =>
        x.sv === sv
          ? {
              ...x,
              st: valor,
            }
          : x
      )
    );
  };

  const handleCantidadMaterial = (sv, valor) => {
    setDetalle(
      detalle.map((x) =>
        x.sv === sv
          ? {
              ...x,
              ca:
                valor === -1 && x.ca <= 1
                  ? 1
                  : parseInt(x.ca ? x.ca : 1) + valor,
            }
          : x
      )
    );
  };

  const handleHabilitarEdicion = (sv, valor, name, e) => {
    setDetalle(detalle.map((x) => (x.sv === sv ? { ...x, [name]: valor } : x)));
    let caja = e.target
      .closest('.op-centrar-componentes')
      .querySelector('input');
    let label = e.target
      .closest('.op-centrar-componentes')
      .querySelector('span');
    caja.style.width = `${label.offsetWidth}px`;
    caja.focus();
  };

  const handleEditarValor = (sv, valor, name) => {
    setDetalle(
      detalle.map((x) =>
        x.sv === sv
          ? {
              ...x,
              [name]: valor < 0 ? 0 : valor,
            }
          : x
      )
    );
  };

  useEffect(() => {
    let total = detalle
      .filter((f) => f.st)
      .reduce((a, b) => a + (b.ps - b.ds) * b.ca, 0);

    handleChange({
      name: 'mp',
      value: formatoMonetario(redondeoDecimales(total + selected.md)),
    });
  }, [detalle]);

  return (
    <>
      <Modal
        title={`Pedido ${pedido.np}`}
        processing={processing}
        onActions={() => (
          <>
            {selected.me === 'NUEPED' && (
              <>
                <Boton
                  className="op-dinamic"
                  icon={() => <AddIcon />}
                  tabIndex={26}
                  style={{ '--button-color': '#3285a8' }}
                  onClick={() => {
                    dispatch(getServiciosAction({}));
                    setOpenServicio(true);
                  }}
                >
                  Agregar servicio
                </Boton>
                <Boton
                  className="op-grabar"
                  disabled={processing}
                  icon={() => <SaveIcon />}
                  onClick={() =>
                    confirmacion('¿Está seguro?', `De recoger el pedido`)
                      .then(() =>
                        dispatch(patchRecogerPedidoAction(pedido, detalle))
                      )
                      .catch(() => {})
                  }
                >
                  Recoger pedido
                </Boton>
              </>
            )}
            {selected.me === 'ENTPED' && (
              <Boton
                className="op-grabar"
                disabled={processing}
                icon={() => <SaveIcon />}
                onClick={() =>
                  confirmacion('¿Está seguro?', `De entregar el pedido`)
                    .then(() => dispatch(patchListoPedidoAction(pedido)))
                    .catch(() => {})
                }
              >
                Entregar pedido
              </Boton>
            )}
          </>
        )}
        onClose={() =>
          confirmacion(
            '¿Deseas cerrar?',
            'La información ingresada se perdera al cerrar la ventana'
          )
            .then(() => {
              dispatch(closeModal());
            })
            .catch(() => {})
        }
      >
        <Texto
          name="av"
          value={selected.av}
          label="Empresa"
          size={3}
          tabIndex={10}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="ns"
          value={selected.ns}
          label="Sucursal"
          size={3}
          tabIndex={11}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="nc"
          value={selected.nc}
          label="Cliente"
          size={3}
          tabIndex={12}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="fp"
          value={selected.fp}
          label="Fecha pedido"
          size={3}
          tabIndex={13}
          disabled
          onChange={() => {}}
        />
        {selected.me === 'LISPED' && (
          <Texto
            name="fe"
            value={selected.fe}
            label="Fecha entrega"
            size={3}
            tabIndex={14}
            disabled
            onChange={() => {}}
          />
        )}
        <Texto
          name="de"
          value={selected.de}
          label="Estado del pedido"
          size={3}
          tabIndex={15}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="fa"
          value={
            selected.fa === 0 ? 'Efectivo' : selected.fa === 1 ? 'Yape' : 'Plin'
          }
          label="Forma de pago"
          size={3}
          tabIndex={16}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="dp"
          value={selected.dp}
          label="Direcci&oacute;n del pedido"
          size={3}
          tabIndex={17}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="rf"
          value={selected.rf}
          label="Referencia de direcci&oacute;n"
          size={3}
          tabIndex={18}
          disabled
          onChange={() => {}}
        />
        <Texto
          name="nt"
          value={selected.nt}
          label="Tel&eacute;fono"
          size={3}
          tabIndex={19}
          disabled
          onChange={() => {}}
        />
        {selected.me === 'NUEPED' && (
          <Texto
            name="nb"
            value={pedido.nb}
            label="N&uacute;mero bolsa"
            size={3}
            tabIndex={20}
            error={errors.nb}
            onChange={handleChange}
          />
        )}
        <div className="op-form-group op-col-1">
          <Tabla
            columns={columns}
            data={detalle}
            pagination={false}
            searcheable={false}
            hoverSelectedRow={false}
            style={{ padding: '0px' }}
          />
          <div className="op-totales">
            <label>Delivery</label>
            <span>{formatoMonetario(redondeoDecimales(pedido.md))}</span>
            <label>
              <strong>Importe Total</strong>
            </label>
            <span>
              <strong>{formatoMonetario(redondeoDecimales(pedido.mp))}</strong>
            </span>
          </div>
        </div>
      </Modal>
      {openServicio && (
        <ServicioList
          searchable
          onClose={() => setOpenServicio(false)}
          onSend={(item) => handleAgregarServicio(item)}
        />
      )}
    </>
  );
};

export default PedidoPick;
